import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import HotComics from './components/HotComics';
import CategorySection from './components/CategorySection';
import RankingSection from './components/RankingSection';
import LatestUpdates from './components/LatestUpdates';

export default function Home() {
  const pageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '43423漫画网 - 免费高清漫画在线阅读',
    description: '在43423漫画网可以免费阅读和观看家教老师漫画，使用下拉式功能便捷浏览所有章节，享受高清画质和流畅体验。',
    url: 'https://43423mh.com',
    inLanguage: 'zh-CN',
    isPartOf: {
      '@type': 'WebSite',
      name: '43423漫画网',
      url: 'https://43423mh.com',
    },
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(pageJsonLd) }} />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <HotComics />
        <CategorySection />
        <RankingSection />
        <LatestUpdates />
      </main>
      <Footer />
    </>
  );
}